import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { UserContractor } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  userContractorId: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, UserContractor>,
    'queryKey' | 'queryFn'
  >;
}

export const useUserContractorRequest = ({ userContractorId, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, UserContractor>(
    [Entities.UserContractors, userContractorId],
    async () => {
      const { data } = await api.v1AdminUsersUsersContractorsUserContractorIdGet(userContractorId)
      return data
    },
    { ...options }
  )
}
